import React, { useState, useRef, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import '../../../../assets/css/Buyer/Home/featureProperty/propertydetail.css';
import { useNavigate } from 'react-router-dom';

const PropertyDetails = ({ isOpen, onClose, property, baseUrlForFiles }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const scrollRef = useRef(null);
  const dragStartRef = useRef(0);
  const scrollLeftRef = useRef(0);
  const navigate = useNavigate();

  // Close modal on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isOpen]);

  // Tabs data
  const tabs = [
    { id: 0, label: 'General Info', number: '01' },
    { id: 1, label: 'About', number: '02' },
    { id: 2, label: 'Characteristics', number: '03' },
    { id: 3, label: 'Exterior', number: '04' },
    { id: 4, label: 'Interior', number: '05' }
  ];


  // Mouse drag for horizontal scroll
  const handleMouseDown = (e) => {
    setIsDragging(true);
    dragStartRef.current = e.pageX - scrollRef.current.offsetLeft;
    scrollLeftRef.current = scrollRef.current.scrollLeft;
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - dragStartRef.current) * 2;
    scrollRef.current.scrollLeft = scrollLeftRef.current - walk;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  if (!isOpen) return null;

  const propertyImages = property?.expropertyimages || [];
  return (
    <div className="home-modal-overlay" onClick={onClose}>
      <div className="home-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <div className="home-modal-close-btn" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>

        {/* Scrollable Content */}
        <div
          className="home-modal-scroll-container"
          ref={scrollRef}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
        >
          <div className="home-modal-content-wrapper">
            {/* Box 1: General Info */}
            <div className="home-modal-box">
              <div className="home-property-card">

                {/* LEFT IMAGE */}
                <div className="home-property-image-wrapper">
                  <img
                    src={`${baseUrlForFiles}${property?.expropertyimages[0]?.images}`}
                    alt={property.property_title}
                    className="home-property-main-image"
                  />
                </div>

                {/* RIGHT CONTENT */}
                <div className="home-box-header">

                  {/* Top Meta */}
                  <div className="home-property-meta">
                    <span className="home-property-number">{property.number}</span>

                    <span className="home-property-location">
                      📍 {property.location}
                    </span>

                    <span className="home-property-type">
                      {property.property_type}
                    </span>
                  </div>



                  {/* Title */}
                  <h2 className="home-property-title">
                    {property.property_title}
                  </h2>
                  {/* Developer */}
                  <div className="home-property-developer">
                    {property.description}
                  </div>

                  {/* Stats */}
                  <div className="home-property-stats">

                    {property?.property_type === "Plot" ? (
                      <>
                        <div className="home-stat-item">
                          <span className="home-stat-label">Size<br /></span>
                          <span className="home-stat-value">{property.size}</span>
                        </div>

                        <div className="home-stat-item">
                          <span className="home-stat-label">Land Area<br /></span>
                          <span className="home-stat-value">{property.land_area}</span>
                        </div>

                        <div className="home-stat-item">
                          <span className="home-stat-label">Plot No.<br /></span>
                          <span className="home-stat-value">{property.plot_number}</span>
                        </div>

                        <div className="home-stat-item">
                          <span className="home-stat-label">Corner Plot<br /></span>
                          <span className="home-stat-value">
                            {property.corner_plot == 1 ? "Yes" : "No"}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="home-stat-item">
                          <span className="home-stat-label">Bedrooms<br /></span>
                          <span className="home-stat-value">{property.bedrooms}</span>
                        </div>

                        <div className="home-stat-item">
                          <span className="home-stat-label">Bathrooms<br /></span>
                          <span className="home-stat-value">{property.bathrooms}</span>
                        </div>

                        <div className="home-stat-item">
                          <span className="home-stat-label">Floors<br /></span>
                          <span className="home-stat-value">{property.floors}</span>
                        </div>

                        <div className="home-stat-item">
                          <span className="home-stat-label">Parking Spaces<br /></span>
                          <span className="home-stat-value">{property.parking_spaces}</span>
                        </div>
                      </>
                    )}

                  </div>

                  {/* Price */}
                  <div className="home-property-price">
                    {property.price}
                    {/* Actions */}
                    <div className="home-property-actions">
                      <button className="home-action-btn home-primary-btn"
                        onClick={() => navigate("/property/1")}
                      >
                        Book Now
                      </button>

                      <button className="home-action-btn home-secondary-btn"
                        onClick={() => navigate("/property/1")}
                      >
                        {/* <svg width="16" height="16" viewBox="0 0 24 24">
               <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
               <polyline points="7 10 12 15 17 10" />
               <line x1="12" y1="15" x2="12" y2="3" />
            </svg> */}
                        View Detail
                      </button>
                    </div>
                  </div>



                </div>
              </div>
            </div>
            {/* Box 2: About */}
            {/* <div className="home-modal-box home-about-box">
             <div className="home-about-card"> */}

            {/* LEFT CONTENT */}
            {/* <div className="home-about-left"> */}

            {/* Header */}
            {/* <div className="home-about-header">
              <div className="home-about-logo">🏢</div>

                <div className="home-about-dev">
                  <span className="home-label">Developer</span>
                  <span className="home-value">{property.developer}</span>
                </div>

              <div className="home-about-project">
                   <span className="home-label">Project</span>
                  <span className="home-value">
                  {property.location} {property.type}
                  </span>
              </div>
           </div> */}

            {/* Title */}
            {/* <h2 className="home-about-title">
             {property.title}
            </h2> */}

            {/* Description */}
            {/* <p className="home-about-description">
            {property.description}
              </p>
              </div> */}

            {/* RIGHT IMAGE */}
            {/* <div className="home-about-image-wrapper">
                <img
                    src={property.exteriorImages[1]}
                    alt="About Property"
                     className="home-about-image"
               /> */}


            {/* </div>

               </div>
            </div> */}


            {/* Box 3: Characteristics */}
            {/* <div className="home-modal-box home-characteristics-box"> */}

            {/* LEFT – AMENITIES */}
            {/* <div className="home-characteristics-content">

                  <h3 className="home-box-section-title">
                       Property characteristics
                  </h3>

                <div className="home-amenities-columns"> */}

            {/* COLUMN 1 */}
            {/* <div className="home-amenities-column">
                 {property.amenities.slice(0, 7).map((amenity, index) => (
              <div key={index} className="home-amenity-row">
                <span className="home-amenity-icon">{amenity.icon}</span>
                <span className="home-amenity-name">{amenity.name}</span>
                <span className="home-amenity-check">✓</span>
              </div>
            ))}
            </div> */}

            {/* COLUMN 2 */}
            {/* <div className="home-amenities-column">
                 {property.amenities.slice(7, 14).map((amenity, index) => (
                    <div key={index} className="home-amenity-row">
                   <span className="home-amenity-icon">{amenity.icon}</span>
                   <span className="home-amenity-name">{amenity.name}</span>
                  <span className="home-amenity-check">✓</span>
                </div>
               ))}
              </div> */}



            {/* COLUMN 3 */}
            {/* <div className="home-amenities-column">
              {property.amenities.slice(14, 20).map((amenity, index) => (
              <div key={index} className="home-amenity-row">
                <span className="home-amenity-icon">{amenity.icon}</span>
                <span className="home-amenity-name">{amenity.name}</span>
               <span className="home-amenity-check">✓</span>
              </div>
               ))} */}
            {/*FEATURED IMAGE 
                <div className="characteristics-image">
                <img
                      src={property.exteriorImages[2]}
                   alt="Property"
                />
                </div>*/}

            {/* </div>
                </div>
               </div>

              </div>
 */}


            {/* Box 4: Exterior */}
            <div className="home-modal-box home-exterior-box">

              {/*<div className="gallery-header"> 
               <h3 className="box-section-title">Exterior</h3>
              </div>*/}

              <div className="home-exterior-gallery">

                { /* LEFT – LARGE IMAGE */}
                <div className="home-exterior-left">
                  <img
                    src={`${baseUrlForFiles}${property?.expropertyimages?.[0]?.images}`}
                    alt="Exterior Main"
                  />

                  {/* <div className="home-gallery-badge">
               <span className="home-badge-title">Gallery</span>
              <span className="home-badge-count">
              {property.exteriorImages.length} Photos <br /> Exterior
              </span>
              <button className="home-badge-btn">View</button>
          </div> */}
                </div>

                {/* RIGHT – GRID IMAGES */}
                <div className="home-exterior-right">
                  {propertyImages?.slice(1, 3).map((img, index) => (
                    <div key={index} className="home-exterior-small">
                      <img src={`${baseUrlForFiles}${img.images}`} alt={`Exterior ${index + 2}`} />
                    </div>
                  ))}
                </div>

              </div>

            </div>


            {/* Box 5: Exterior */}
            {/* <div className="home-modal-box home-exterior-box"> */}

            {/*
              <div className="gallery-header">
               <h3 className="box-section-title">Interior</h3>
             </div>
             */}

            {/* <div className="home-exterior-gallery"> */}

            {/* LEFT – LARGE IMAGE */}
            {/* <div className="home-exterior-left">
            <img
            src={property.exteriorImages[0]}
             alt="Exterior Main"
            />
            <div className="home-gallery-badge">
               <span className="home-badge-title">Gallery</span>
              <span className="home-badge-count">
              {property.exteriorImages.length} Photos <br /> Interior
              </span>
              <button className="home-badge-btn">View</button>
             
            </div>
          </div> */}

            {/* RIGHT – GRID IMAGES */}
            {/* <div className="home-exterior-right">
          {property.exteriorImages.slice(1, 5).map((img, index) => (
           <div key={index} className="home-exterior-small">
               <img src={img} alt={`Exterior ${index + 2}`} />

            
            </div>
             
            ))}
          </div> */}

            {/* </div> */}

            {/* </div>
          */}
          </div>
        </div>
        {/* Bottom Navigation Tabs 
        <div className="modal-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-number">{tab.number}.</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>*/}
      </div>
    </div>

  );
};

export default PropertyDetails;